/* eslint-disable react-hooks/exhaustive-deps */
//import { useState } from "react";
import { Button } from 'antd';
import IconSuccressMail from '../../../assets/Images/icons/icon-seccess-mail';
import IconLogo from '../../../assets/Images/icons/icon-logo';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SuccessForm(props) {
    let navigate = useNavigate();
    const { t } = useTranslation();
    return (
        <>
            <div className="justify-center" style={{ width: 700 }}>
                <div
                    className="text-4xl mt-6 mb-2 "
                    style={{ color: '#A8A8AF', textAlign: 'center' }}
                >
                    <IconLogo />
                </div>
                <div
                    className="text-4xl mt-6 mb-2 "
                    style={{ color: '#A8A8AF', textAlign: 'center' }}
                >
                    <IconSuccressMail />
                </div>
                <div
                    className="mb-4 pt-6 "
                    style={{
                        textAlign: 'center',
                        fontSize: 16,
                        padding: '0px 26%',
                    }}
                >
                    {props.currentPageAction.text === 'RESETMAIL' ? (
                        <>
                            <span>{t('passwordPage.SuccessfullyResetPassword')}</span>
                        </>
                    ) : (
                        <>
                            <span>{t('passwordPage.SuccessfullyResetPassword2')}</span>
                        </>
                    )}
                </div>
                <div
                    className="mb-4  pl-16 pr-16"
                    style={{
                        textAlign: 'center',
                        fontSize: 12,
                        padding: '0px 26%',
                    }}
                >
                    <p>
                        {t('passwordPage.SentPasswordRecoverInstructions')}
                    </p>
                </div>
                <div className=" mb-4 pt-6 " style={{ padding: '0px 20%' }}>
                    <Button
                        className="w-full flex items-center justify-center "
                        style={{
                            color: '#fff',
                            backgroundColor: '#7B67FB',
                            borderRadius: '7px',
                        }}
                        size="large"
                        //shape="round"
                        //loading={loading}
                        //type="primary"
                        htmlType="submit"
                        onClick={() => {
                            navigate('/login');
                        }}
                    >
                        {t('passwordPage.BackToLogin')}
                    </Button>
                </div>
            </div>
        </>
    );
}
